<template>
    <div>
        <!-- <label>{{text}}</label>   -->
        <span style="font-size: 14px;font-weight: bold;">{{ attrs.display }}</span>
        <span style="font-size: 18px;font-weight: bold; color: #39b54a;">{{ text }}</span>
    </div>
</template>
<script>
    /**
     * 套餐价格组件说明，
     * 套餐的选择是radio，其id需要特殊配合。 id_21 ID后面要跟价格，在传过来的的page中才能得到价格进行计算
     * 目前这个只做显示
     */
    export default {
        name: 'LyTaocanPrice',
        props: {
            page: {
                type: Object,
                default: _ => {}
            },
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return {
                countFields: []
            }
        },
        computed: {
            /**
             * 显示价格的文字
             */
            text () {
                let price = 0
                this.countFields.forEach(el => {
                    if (el.indexOf('[') > 0) { // 取数组中的值
                        el = el.replace(']', '')
                        const keyArr = el.split('[')
                        const val = this.page[keyArr[0]]
                        val.forEach(item => {
                            price += parseFloat(item[keyArr[1]])
                        })
                    } else {
                        let mun = el.indexOf('-')
                        if (mun >= 0) {
                            el = el.replace('-', '')
                        }
                        let value = this.page[el]
                        if (mun >= 0) {
                            value *= -1
                        }
                        if (value) {
                            let index = String(value).indexOf('_')
                            if (index > 0) {
                                let number = value.substring(index + 1, value.length)
                                price = parseFloat(price) + parseFloat(number)
                            } else {
                                price = parseFloat(price) + parseFloat(value)
                            }
                        }  
                    }
                })
                const returnVal = isNaN(price) ? 0 : price.toFixed(2) 
                
                this.$emit('input', returnVal)
                return returnVal
            }
        },
        created () {
            this.countFields = this.attrs.countFields.split(',')
        }
    }
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/taocan-price/src/index.vue